import { TWhiteLabel } from '../white-label.model';
import { getDefaultPanelColors } from './get-default-panel-colors';
import { getDefaultPrimaryColors } from './get-default-primary-colors';
import { WHITE_LABEL_COLOR_KEYS } from './has-custom-colors';

const isDefaultColor = (color: string, defaultColor: string): boolean =>
  (color ?? '').toLowerCase() === defaultColor.toLowerCase();

export function clearDefaultColors(data: TWhiteLabel): TWhiteLabel {
  const defaultColors: TWhiteLabel = { ...getDefaultPanelColors(), ...getDefaultPrimaryColors() };

  return WHITE_LABEL_COLOR_KEYS.reduce(
    (whiteLabel, key) =>
      isDefaultColor(data[key], defaultColors[key]) ? { ...whiteLabel, [key]: '' } : whiteLabel,
    { ...data },
  );
}
